import { GroupInput } from '@/components';
import { getDisableTimeOnly, getFieldDateProps } from '@/utils';
import { ClockCircleOutlined } from '@ant-design/icons';
import { memo, useCallback } from 'react';

import { TimePicker as TimePickerAntd } from 'antd';
import locale from 'antd/es/date-picker/locale/ko_KR';

import { Dayjs } from 'dayjs';
import { FormikProps } from 'formik';

import { EEditableFilterType, TSelectTimeValue } from './type';

export const filterTimeDefaultValue: TSelectTimeValue = {
	type: EEditableFilterType.TIME_PICKER,
	startTime: '',
	endTime: '',
};

export type TFilterTime = {
	formik: FormikProps<{ [key: string]: any }>;
	label: string;
	name: string;
	labelClassName?: string;
	containerClassName?: string;
	format?: string;
	onSearch?: () => void;
	option?: {
		format?: boolean;
	};
	defaultValue?: TSelectTimeValue;
};

const FilterTime = ({
	formik,
	label,
	name,
	labelClassName,
	containerClassName,
	format,
	onSearch,
}: TFilterTime) => {
	const DATE_FORMAT = format || 'HH:mm';

	const startTimeProps = getFieldDateProps(formik, `${name}.startTime`, {
		onAfterDateChange: onSearch,
		timeOnly: true,
		format: true,
	});

	const endTimeProps = getFieldDateProps(formik, `${name}.endTime`, {
		onAfterDateChange: onSearch,
		timeOnly: true,
		format: true,
	});

	const disabledStartTime = useCallback(
		(current: Dayjs) => {
			return getDisableTimeOnly(current, endTimeProps?.value, true);
		},
		[endTimeProps?.value]
	);

	const disabledEndTime = useCallback(
		(current: Dayjs) => {
			return getDisableTimeOnly(current, startTimeProps?.value, false);
		},
		[startTimeProps?.value]
	);

	return (
		<GroupInput
			label={label}
			labelClassName={labelClassName}
			containerClassName={containerClassName}
			groupClassName="flex-none gap-x-1.5"
		>
			<TimePickerAntd
				{...startTimeProps}
				className="h-[30px] w-[200px] rounded-none"
				format={DATE_FORMAT}
				placeholder=""
				suffixIcon={<ClockCircleOutlined />}
				inputReadOnly
				locale={{
					...locale,
					lang: {
						...locale.lang,
						now: 'Now',
						ok: 'Ok',
					},
				}}
				disabledTime={disabledStartTime}
			/>
			<span className="text-[13px] text-font4">~</span>
			<TimePickerAntd
				{...endTimeProps}
				className="h-[30px] w-[200px] rounded-none"
				format={DATE_FORMAT}
				placeholder=""
				suffixIcon={<ClockCircleOutlined />}
				inputReadOnly
				locale={{
					...locale,
					lang: {
						...locale.lang,
						now: 'Now',
						ok: 'Ok',
					},
				}}
				disabledTime={disabledEndTime}
			/>
		</GroupInput>
	);
};

export default memo(FilterTime);
